import styled from 'styled-components';
import tw from 'tailwind.macro';

export const GoToTop= styled.div`  
.GoToTop{
  float: right
}
`;

